import React, {useState} from 'react'
import {motion} from 'framer-motion'
import LinkDirectoryRow from './LinkDirectoryRow'
import SafeIcon from '../../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const {FiChevronLeft, FiChevronRight} = FiIcons

const LinkDirectoryTable = ({opportunities, user, currentPage, totalPages, onPageChange, onStatusUpdate, onReportBrokenLink, onFavorite, onStatusChange, userActions={}, onPurchaseClick, defaultValues, onSendEmail}) => {
  if (opportunities.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-8 text-center dark:bg-gray-800">
        <p className="text-gray-600 text-lg dark:text-gray-400">No opportunities found matching your criteria.</p>
      </div>
    )
  }

  const generatePageNumbers = () => {
    const pages = []
    const maxVisiblePages = 5

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          pages.push(i)
        }
        pages.push('...')
        pages.push(totalPages)
      } else if (currentPage >= totalPages - 2) {
        pages.push(1)
        pages.push('...')
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i)
        }
      } else {
        pages.push(1)
        pages.push('...')
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i)
        }
        pages.push('...')
        pages.push(totalPages)
      }
    }

    return pages
  }

  return (
    <motion.div
      initial={{opacity: 0, y: 20}}
      animate={{opacity: 1, y: 0}}
      className="bg-white rounded-2xl shadow-lg overflow-hidden dark:bg-gray-800"
    >
      {/* Table Header */}
      <div className="bg-gray-50 px-6 py-4 border-b dark:bg-gray-700 dark:border-gray-600">
        <div className="grid grid-cols-1 md:grid-cols-8 gap-4 text-sm font-semibold text-gray-700 dark:text-gray-300">
          <div className="md:col-span-1" style={{width: '50%'}}>State</div>
          <div className="md:col-span-1">Niche</div>
          <div className="md:col-span-1">Type</div>
          <div className="md:col-span-2">Opportunity</div>
          <div className="md:col-span-1">Contact</div>
          <div className="md:col-span-1">Actions</div>
        </div>
      </div>

      {/* Table Body */}
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        {opportunities.map((opportunity) => (
          <LinkDirectoryRow
            key={opportunity.id}
            opportunity={opportunity}
            user={user}
            onStatusUpdate={onStatusUpdate}
            onReportBrokenLink={onReportBrokenLink}
            onFavorite={onFavorite}
            onStatusChange={onStatusChange}
            userActions={userActions}
            onPurchaseClick={onPurchaseClick}
            defaultValues={defaultValues}
            onSendEmail={onSendEmail}
          />
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="bg-gray-50 px-6 py-4 border-t dark:bg-gray-700 dark:border-gray-600">
          <div className="flex items-center justify-between">
            <div className="text-sm text-gray-700 dark:text-gray-300">
              Page {currentPage} of {totalPages}
            </div>

            <div className="flex items-center space-x-2">
              <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="flex items-center px-3 py-2 text-sm text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed dark:text-gray-400 dark:hover:text-gray-200"
              >
                <SafeIcon icon={FiChevronLeft} className="w-4 h-4 mr-1" />
                Previous
              </button>

              <div className="flex space-x-1">
                {generatePageNumbers().map((page, index) => (
                  <button
                    key={index}
                    onClick={() => typeof page === 'number' ? onPageChange(page) : null}
                    disabled={page === '...'}
                    className={`px-3 py-2 text-sm rounded-md ${
                      page === currentPage
                        ? 'bg-[#D59A4C] text-white'
                        : page === '...'
                        ? 'text-gray-400 cursor-default dark:text-gray-500'
                        : 'text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-600'
                    }`}
                  >
                    {page}
                  </button>
                ))}
              </div>

              <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="flex items-center px-3 py-2 text-sm text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed dark:text-gray-400 dark:hover:text-gray-200"
              >
                Next
                <SafeIcon icon={FiChevronRight} className="w-4 h-4 ml-1" />
              </button>
            </div>
          </div>
        </div>
      )}
    </motion.div>
  )
}

export default LinkDirectoryTable